import { TileType, Rotation, Port } from '../types';

// Ports for each tile type at rotation 0
// N = top, E = right, S = bottom, W = left
export const BASE_PORTS: Record<TileType, Port[]> = {
  deadend:  ['N'],
  straight: ['N', 'S'],
  lbend:    ['N', 'E'],
  tee:      ['N', 'E', 'S'],
  cross:    ['N', 'E', 'S', 'W'],
  empty:    [],
};

const PORT_ORDER: Port[] = ['N', 'E', 'S', 'W'];

function rotatePort(port: Port, rotation: Rotation): Port {
  const idx = PORT_ORDER.indexOf(port);
  const steps = rotation / 90;
  return PORT_ORDER[(idx + steps) % 4];
}

export function getActivePorts(type: TileType, rotation: Rotation): Port[] {
  return BASE_PORTS[type].map(p => rotatePort(p, rotation));
}

// Opposite port for connection checking
export const OPPOSITE_PORT: Record<Port, Port> = {
  N: 'S', S: 'N', E: 'W', W: 'E',
};

// Direction delta for each port
export const PORT_DELTA: Record<Port, [number, number]> = {
  N: [-1, 0],
  S: [1, 0],
  E: [0, 1],
  W: [0, -1],
};

// Given a set of ports, find which tile type + rotation matches
export type TileVariant = { type: TileType; rotation: Rotation };

export function findTileVariant(ports: Set<Port>): TileVariant | null {
  const rotations: Rotation[] = [0, 90, 180, 270];
  const types: TileType[] = ['deadend', 'straight', 'lbend', 'tee', 'cross'];

  for (const type of types) {
    for (const rotation of rotations) {
      const active = new Set(getActivePorts(type, rotation));
      if (active.size === ports.size && Array.from(ports).every(p => active.has(p))) {
        return { type, rotation };
      }
    }
  }
  return null;
}
